import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import UserName from "../../components/user/UserDetail/UserName.tsx";
import {useLocationFormState} from "../../components/user/UserForm/UserUpdateForm";
import UserUpdateFormProvider from "../../components/user/UserForm/UserUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const UserUpdateEditPage = () => {
    
    useTitle(t`Update User`);

    const { userId: id } = useParams();
    
    return (
        <Box data-testid="User-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="User-update-title"
                    >
                        <Trans>Edit User</Trans>:  <UserName id={id}/>
                    </Typography>
                    <UserUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default UserUpdateEditPage;
